import { withDependencies, named } from '@wix/thunderbolt-ioc'
import type { TpaHandlerProvider } from '@wix/thunderbolt-symbols'
import { SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { TpaCommonsSiteConfig } from 'feature-tpa-commons'
import { name as tpaCommonsName } from 'feature-tpa-commons'

export type MessageData = {
	appDefinitionId: string
}

export const GetApplicationFieldsHandler = withDependencies(
	[named(SiteFeatureConfigSymbol, tpaCommonsName)],
	({ appsClientSpecMapData }: TpaCommonsSiteConfig): TpaHandlerProvider => ({
		getTpaHandlers(): any {
			return {
				getApplicationFields(compId: string, { appDefinitionId }: MessageData) {
					return appsClientSpecMapData[appDefinitionId].appFields
				},
			}
		},
	})
)
